import { render } from "./AnamneseFormulario.vue?vue&type=template&id=677bdd5c&scoped=true"
import script from "./AnamneseFormulario.vue?vue&type=script&lang=js"
export * from "./AnamneseFormulario.vue?vue&type=script&lang=js"

import "./AnamneseFormulario.vue?vue&type=style&index=0&id=677bdd5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677bdd5c"]])

export default __exports__